/**
 * After Auction
 */
// Used as an enum for biddingStatus.status_type
export const SOLD = 'Sold'
export const PENDING = 'Pending'
export const FOR_SALE = 'For Sale'
export const UNDER_CONTRACT = 'Under Contract'
export const CLOSING_WAITING_PERIOD_DAYS = 1
export const HIDE_STARTING_BID_STATES = ['Kentucky']
export const ACTIVE_POSTPONED_TO = 'Active - Postponed to'
export const NEW_DATE_PENDING = 'For Sale - New Date Pending'
/**
 * Bid box constants
 */
export const POLLING_FETCH_MAX_WAIT = 30 // max wait before we force another fetch
export const POLLING_INTERVAL_NOT_IN_AUCTION = 120
// if time remaing is less than this, don't do (slower) POLLING_INTERVAL_NOT_IN_AUCTION polling
export const POLLING_TIMER_FINISHING_THRESHOLD = 300
export const POLLING_INTERVAL_FINAL_OFFER_PENDING = 8
export const POLLING_INTERVAL_IN_AUCTION_LOGGED_IN = 4
// If fewer than this many seconds have passed since the auction ended,
// don't switch to (slower) POLLING_INTERVAL_NOT_IN_AUCTION polling yet.
export const POLLING_TIMER_AFTER_AUCTION_THRESHOLD = 30
export const POLLING_INTERVAL_PREPARING_CONTRACT_FORM = 8
export const POLLING_INTERVAL_IN_AUCTION_NOT_LOGGED_IN = 12

/**
 * Mao constants
 */
export const PREAUCTION_URGENCY_PERIOD_THRESHOLD = 3

/**
 * Offsets
 */
export const SERVER_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ssZZ'
